/**
 * Für uns / Nur ich — defaults for household agenda visibility.
 * Keep in sync with server/lib/scheduleVisibility.js
 */

import { isEventActionType, isTaskActionType } from "./schoolAttention";

export const VISIBILITY_MINE = "mine";
export const VISIBILITY_HOUSEHOLD = "household";

export const VISIBILITY_LABEL_MINE = "Nur ich";
export const VISIBILITY_LABEL_HOUSEHOLD = "Für uns";

/**
 * @param {unknown} value
 * @returns {'mine'|'household'}
 */
export function parseVisibility(value) {
  return value === VISIBILITY_HOUSEHOLD ? VISIBILITY_HOUSEHOLD : VISIBILITY_MINE;
}

/**
 * KiTa attention items default to household when the parent is linked.
 * Manual Merken stays private. A confirmed flyer is Für uns once a partner
 * is linked. Mail Aufgaben and Termine are Für uns too.
 *
 * @param {object|null|undefined} event
 * @param {number[]} [kitaWeekdays]
 * @param {{ hasHousehold?: boolean, sourceKind?: string }} [opts]
 * @returns {'mine'|'household'}
 */
export function defaultVisibilityForEvent(
  event,
  _kitaWeekdays = [],
  { hasHousehold = false, sourceKind = "mail" } = {},
) {
  if (!hasHousehold) return VISIBILITY_MINE;
  const kind = String(sourceKind || "mail").toLowerCase();
  if (kind === "manual") return VISIBILITY_MINE;
  if (kind === "capture") return VISIBILITY_HOUSEHOLD;
  const actionType = event?.action_type ?? event?.actionType;
  if (isTaskActionType(actionType) || isEventActionType(actionType)) {
    return VISIBILITY_HOUSEHOLD;
  }
  return VISIBILITY_MINE;
}
